import { PickUpCenter } from "./utils";

export class ActivationRequest{
  id_user : string  = ''
  password : string = ''
  guid : string = ''

  constructor (values : any){
      (<any>Object).assign(this, values);
  }

}

export class UserAddress {
  address_name: string = '';
  address_type: number = 0;          // 1=Factura, 2=Entrega
  centre_ClickRecull :string = '';
  address_street: string = '';
  address_number: string = '';
  address_stair: string = '';
  address_floor: string = '';
  address_door: string = '';
  zipcode: string = '';
  city: string = '';
  province: string = '';
  isprimary: number = 0;
  observ : string= '';
  recid : string = '';

  mapURL : any;
  
  constructor(values: Object = {}) {
    (<any>Object).assign(this, values);
  }

  public get addressing () : string {
    return `${this.address_street} ${this.address_number}, ${this.zipcode} ${this.city}, ${this.province}`;
  }
}

//20250602 axa inici
export class User_AxA_Address {
  address_name: string = '';
  zipcode: string = '';
  recid: string = '';
  address_details: UserAddress;
  mapURL: any;


  constructor(values: Object = {}) {
    (<any>Object).assign(this, values);
  }
  public get addressing(): string {
    return `${this.address_details.address_street} ${this.address_details.address_number}, ${this.zipcode} ${this.address_details.city}, ${this.address_details.province}`;
  }

}
//20250602 axa final


export class User   {
  token?: string;
  payload: Payload;

  id_user: string = '';
  email: string = '';
  password: string = '';
  name: string = '';
  surname1: string = '';
  dni: string = '';
  phone1: string = '';
  phone2: string = '';
  birth_date: string = '' ;
  subst_policy: number = 0;
  birth_plusi_card: string = '';
  phone_plusi_card: string = '';
  id_plusi_card: string = '';
  get_plusi_card: number = 0;

  language : string = '';
  rgpd: number = 0;
  user_agent: string = '';
  publi: number = 0;
  //20250602 axa inici
  factura_electronica: number = 0;
  //20250602 axa final

  nobags: string;
  
  user_addresses: UserAddress[] = [];
  
  constructor(values: Object = {}) {
    Object.assign(this, values);
    
    if (this.user_addresses){
      this.user_addresses = this.user_addresses.map( address => new UserAddress(address));
    }
  }

  public get birthDay() : number {
    return parseInt(this.birth_date.split('/')[0]);
  }
  public get birthMonth() : number {
    return parseInt(this.birth_date.split('/')[1]);
  }
  public get birthYear() : number {
    return parseInt(this.birth_date.split('/')[2]);
  }

  public get hasPlusiCard() : boolean {
    return this.get_plusi_card == 0  && this.id_plusi_card != null && this.id_plusi_card != '' ;
  }
  public get primaryAddress () : UserAddress {
    return this.user_addresses.find( address => address.isprimary == 1);
  }


}


export class Payload{
  aud: string
  exp: number
  iat: number
  iss: string
  nameid: string
  nbf: number
  unique_name: string
}

export class PlusiPoints {
  plusi_points: number 
  active_promos: Promo[]
}

export class Promo{
  promo_name : string
  promo_points : number
}
//20250602 axa inici
export class UserAxA {
  id_user: string = '';
  temp_AxA_id: string;
  custLanguage: string;
  user_AxA_addresses: User_AxA_Address[] = [];
  center_AxA_addresses: PickUpCenter[] = [];

  constructor(values: Object = {}) {
    Object.assign(this, values);

    if (this.user_AxA_addresses) {
      this.user_AxA_addresses = this.user_AxA_addresses.map(address => new User_AxA_Address(address));
    }
  }
}
//20250602 axa final
